// extracted by mini-css-extract-plugin
export default {"row":"appInformation_row__Pcmdq","col":"appInformation_col__mUWwJ","card":"appInformation_card__55YcQ"};